import React from 'react';
import { Phone, Mail, Pencil, Trash2, MapPin, Briefcase, Heart, Building2 } from 'lucide-react';
import { CONTACT_CATEGORY_BY_ID } from './helpers';

const DetailIcon = ({ cat }) => {
  if (cat === 'bank_staff') return <Building2 className="icon" />;
  if (cat === 'client') return <MapPin className="icon" />;
  if (cat === 'dsa') return <Briefcase className="icon" />;
  if (cat === 'referral') return <Heart className="icon" />;
  return null;
};

export default function ContactCard({ contact, onEdit, onDelete }) {
  const cat = CONTACT_CATEGORY_BY_ID[contact.category] || { label: 'Unknown', color: '#78716c', bg: '#f5f5f4', dark: '#44403c' };
  const detail = (() => {
    if (contact.category === 'bank_staff') {
      const parts = [contact.bank, contact.branch].filter(Boolean).join(' · ');
      return contact.designation ? `${contact.designation}${parts ? ` — ${parts}` : ''}` : parts;
    }
    if (contact.category === 'client') return contact.property_location || '';
    if (contact.category === 'dsa') return contact.agency || '';
    if (contact.category === 'referral') return contact.relation || '';
    return '';
  })();

  return (
    <div className="contact-card" style={{ borderLeftColor: cat.color }} data-testid={`contact-card-${contact.id}`}>
      <div className="contact-card-header">
        <div className="contact-name" data-testid={`contact-name-${contact.id}`}>{contact.name}</div>
        <span className="contact-cat-badge" style={{ background: cat.bg, color: cat.dark }}>{cat.label}</span>
      </div>

      {detail && (
        <div className="contact-detail-line">
          <DetailIcon cat={contact.category} /> <span>{detail}</span>
        </div>
      )}

      <div className="contact-meta">
        {contact.mobile && (
          <a href={`tel:${contact.mobile}`} className="contact-meta-link" data-testid={`contact-mobile-${contact.id}`}>
            <Phone className="icon" /> {contact.mobile}
          </a>
        )}
        {contact.email && (
          <a href={`mailto:${contact.email}`} className="contact-meta-link" data-testid={`contact-email-${contact.id}`}>
            <Mail className="icon" /> {contact.email}
          </a>
        )}
      </div>

      {contact.notes && (
        <div className="contact-notes">{contact.notes}</div>
      )}

      <div className="contact-card-actions">
        <button className="contact-btn-edit" onClick={() => onEdit(contact)} data-testid={`edit-contact-${contact.id}`}>
          <Pencil className="icon" /> Edit
        </button>
        <button className="contact-btn-delete" onClick={() => onDelete(contact)} data-testid={`delete-contact-${contact.id}`}>
          <Trash2 className="icon" /> Delete
        </button>
      </div>
    </div>
  );
}
